module.exports = __webpack_public_path__ + "img/brookingk.58b0ddf4.jpg";